class PermittedUser {
  id?: string;

  email = '';

  name = '';

  firstname = '';

  lastname = '';

  /** The contact address this person shares with this office. Per office, unlike the name. */
  sharedEmail?: string;

  /** The number this person shares with this office. */
  phoneNumber?: string;

  /** Whether this person is a company medic (first aider) in this office. */
  isCompanyMedic = false;

  /**
   * The office-local date their access is scheduled to end (`yyyy-MM-dd`), or undefined when they
   * are not leaving. Shown in the list so a second administrator cannot schedule the same person
   * for a different day, or remove them by hand a fortnight early.
   */
  accessEndsOn?: string;

  /** When the job applied it. Distinguishes "access ends" from "access ended". */
  accessEndAppliedAt?: string;
}

export default PermittedUser;
